import { render } from "./Edit.vue?vue&type=template&id=339ce918"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__